import React from "react";

export const STATUS_META = {
  COMPLET: { label: "En attente CQ", cls: "badge-complet" },
  INCOMPLET: { label: "Incomplet", cls: "badge-incomplet" },
  A_VERIFIER: { label: "À vérifier", cls: "badge-verifier" },
  ERREUR: { label: "Erreur", cls: "badge-erreur" },
  PROCESSING: { label: "En cours…", cls: "badge-processing" },
  TRAITE: { label: "Archivé", cls: "badge-processing" },
  IMPORTE: { label: "Importé Chelly", cls: "badge-importe" },
};

export function ChellyStatus({ d, className = "" }) {
  if (!d?.chelly?.status) return null;
  return <div className={`text-[10px] text-teal-700 mt-1 ${className}`} data-testid="chelly-status">Chelly : {d.chelly.status}</div>;
}

export default function StatusBadge({ status, testid }) {
  const meta = STATUS_META[status] || STATUS_META.PROCESSING;
  return (
    <span className={`badge-status ${meta.cls}`} data-testid={testid || `status-${status}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-60" />
      {meta.label}
    </span>
  );
}
